module.exports = __webpack_public_path__ + "img/sankaku_37_red.5b5313aa.png";